module.exports = __webpack_public_path__ + "assets/img/logo-w.331f370c.png";